import snakeCase from 'lodash/snakeCase';
import { connect } from 'react-redux';

import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { segmentTrack } from 'src/app/state/actions';
import type { Dispatch } from 'src/app/state/store';

import { StripeInput } from '.';

export { FieldOptions } from '.';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchFieldFocused: (elementType: string) => {
    const payload = {
      pagepath: window.location.pathname,
      fieldname: snakeCase(elementType),
    };
    return dispatch(segmentTrack(UNIFIED.fieldFocused, payload));
  },
});

const TextInputStripe = connect(null, mapDispatchToProps)(StripeInput);

TextInputStripe.displayName = 'TextInputStripe';
export { TextInputStripe };
